import { Injectable } from '@angular/core';

import { MessageType } from '@cds/push';
import { SlimScoreboardCommand } from '@cds/push/fixture-commands';
import { ScoreboardSlim } from '@cds/scoreboards/v1';
import { ScoreboardFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { ConnectionConfig } from '@frontend/sports/common/client-config-data-access';
import { CdsPushService, CdsSubscription, ScoreboardSlimSubscription } from '@frontend/sports/content-distribution/feature';
import { BaseSubscriptionService, MessageCallback, MessageHandler } from '@frontend/sports/event-subscription/feature/base-subscription';

@Injectable({ providedIn: 'root' })
export class ScoreboardSlimSubscriptionService extends BaseSubscriptionService<EventModel> {
    constructor(
        private scoreboardFactory: ScoreboardFactory,
        push: CdsPushService,
        protected connection: ConnectionConfig,
    ) {
        super(push);
    }

    protected getContextSubscriptions(event: EventModel, callback: MessageCallback): CdsSubscription[] {
        return [new ScoreboardSlimSubscription(event.offerContext, event.id, this.connection.culture, callback)];
    }

    protected getHandlers(): Map<MessageType, MessageHandler<EventModel>> {
        const handlers = new Map<MessageType, MessageHandler<EventModel>>();

        handlers.set(MessageType.ScoreboardSlim, (evt, cmd) => this.updateScoreboard(evt, cmd as SlimScoreboardCommand));

        return handlers;
    }

    private updateScoreboard(event: EventModel, command: SlimScoreboardCommand): EventModel {
        const scoreboard = command.scoreboard as ScoreboardSlim;
        event.scoreboard = this.scoreboardFactory.createScoreboard(scoreboard, event);

        return event;
    }
}
